module.exports = __webpack_public_path__ + "static/paneheaderhovered-b748898e94942c0b5ecb82d6fc0f12ce.png";